import _ from 'lodash';
import {connect} from 'react-redux';

import {BannerTypesEnum} from '../../../../../libs/shared/core/src/store/banners/commonBannerState';
import {AppPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {
  createShallowEqualSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {makeGetVisibleBannersForPanel} from '../../../../store/panels/app/banners/bannersSelectors';
import {undoLastBannerAsyncAction} from '../../../../store/panels/app/banners/undoBannersActions';
import {UndoBanners} from './undoBanners';

/*
 * Props.
 */

interface UndoBannersContainerProps {
  panelId: AppPanelId;
}

/*
 * Selectors.
 */

function makeGetSortedUndoBanners() {
  return createShallowEqualSelector([makeGetVisibleBannersForPanel()], (visibleBanners) =>
    _(visibleBanners)
      .map((b) => b.type === BannerTypesEnum.UNDO && b)
      .compact()
      .value(),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<UndoBannersContainerProps>()(() => ({
  banners: makeGetSortedUndoBanners(),
}));

const mapDispatchToProps = makeMapDispatchToProps<UndoBannersContainerProps>()(({panelId}) => ({
  onUndoLastBannerClick: () => undoLastBannerAsyncAction(panelId),
}));

export const UndoBannersContainer = connect(mapStateToProps, mapDispatchToProps)(UndoBanners);
